import React, { useContext, useEffect, useState } from "react"
import { isMobileOnly } from 'react-device-detect'
import { SEARCH, SearchContext } from './SearchContext'
import HotelsList from '../hotel/HotelsList'
import FiltersList from './filtering/FiltersList'
import Loading from '../common/Loading'
import HotelsPagination from '../hotel/HotelsPagination'
import {
  getViewportSearchHeight,
  setMainDashboardHeight,
  responsiveHeightsCheck
} from '../helpers/contentRenderHelper'
import useResizeObserver from '../../common/hooks/useResizeObserver'

const _displayNoResults = () => (
  <div className="section no-results">
    <h1>No Hotels found</h1>
    <h2>for this search</h2>
    <p>Please try again</p>
  </div>
)

const _displayErrors = () => (
  <div className="section no-results server-errors errors">
    <h1>We are unable to list hotels</h1>
    <h1>for this search</h1>
    <h2>We apologize for the inconvenience</h2>
    <p>Please try your search again or contact us</p>
  </div>
)

const _displayStartingMessage = () => (
  <div className="section no-results starting-message">
    <h2>Choose from <strong>180,000+</strong><br/> hotels &amp; resorts nationwide</h2>
    <h2>Book online in <strong>seconds</strong>.</h2>
    <p><i className="fas fa-search"></i>Use the search bar to get started</p>
  </div>
)

const SearchResults = () => {
  const { state, dispatch } = useContext(SearchContext)
  const _setCurrentHotels = (hotels) => dispatch({ type: SEARCH.CURRENT_HOTELS.SET, payload: hotels })
  const _setVisibleHotels = (hotels) => dispatch({ type: SEARCH.VISIBLE_HOTELS.SET, payload: hotels })
  const [smallScreen, setSmallScreen] = useState(isMobileOnly)

  var resizeId, resizeLongerCheckId, heightCheckId

  const _resizerActions = (entries) => {
    setSmallScreen(isMobileOnly || window.innerWidth < 765)
    if(entries) {
      entries.forEach(() => {
        clearTimeout(resizeId)
        resizeId = setTimeout(setResponsiveHeights, 500)
        clearTimeout(resizeLongerCheckId)
        resizeLongerCheckId = setTimeout(responsiveHeightsCheck, 3000)
      })
    }
  }
  const [resizer] = useResizeObserver(_resizerActions)

  const setResponsiveHeights = () => {
    getViewportSearchHeight()
    setMainDashboardHeight()
  }

  const _responsiveHeightCheck = () => {
    clearTimeout(heightCheckId)
    responsiveHeightsCheck()
    heightCheckId = setTimeout(_responsiveHeightCheck, 8000)
  }

  const _setHotels = (newCurrent) => {
    _setCurrentHotels(newCurrent)
    _setVisibleHotels(newCurrent)
  }

  useEffect(() => {
    resizer.observe(document.body)
    if(document.querySelector("main.dashboard"))
      resizer.observe(document.querySelector("main.dashboard"))
    setResponsiveHeights()
    if(smallScreen) _responsiveHeightCheck()
  },[])

  const _displayNoResultsFromFilters = () => (
    <div className="section no-results filters">
      <h1>No Matching Hotels found</h1>
      <p>Try removing some filters to see more</p>
      <FiltersList />
    </div>
  )

  const _render = () => {

    if (state.serverErrors && state.serverErrors.length > 0)
      return _displayErrors()

    if(state.displaySearchMessage && state.hotels.length <= 0)
      return _displayStartingMessage()

    if (!state.isLoading && state.initiateFilterSearch.value && state.hotels.length === 0)
      return _displayNoResultsFromFilters()

    return (!state.hotels || state.hotels.length === 0)
      ? _displayNoResults()
      : <HotelsList
          setHotels={_setHotels}
        />
  }

  return (
    <React.Fragment>
      <div id="search" className={`viewport search ${
        state.showExtraFields ? 'show-extra-fields' : ''} ${
          state.hotels.length ? 'hotels-active' : ''
        }`}>
        { state.isLoading && (
            <Loading
              searchReloading={state.searchReloading}
              randomText
              className={`${(state.initiateFilterSearch.value || state.initiatePageChange) ? ' opaque-background' : ''}`} />
          )
        }
        {_render()}
      </div>
      {
        smallScreen && state.hotels.length &&
        <HotelsPagination
          setHotels={_setHotels}
        />
      }
    </React.Fragment>
  )

}

export default SearchResults
